import emailjs from "emailjs-com";
import { ContactValues } from "../types/RandomGlobalTypes";

class ContactService {
  private serviceId = "service_opke8bq";
  private templateKey = "template_s6m2u69";
  private publicKey = "Iw9ZW9IaKBRfTd40k";

  async contact(values: ContactValues) {
    try {
      const response = await emailjs.send(
        this.serviceId,
        this.templateKey,
        {
          name: values.fullName,
          email: values.email,
          phone: values.phone,
          subject: values.subject,
          message: values.message,
        },
        this.publicKey
      );

      console.log("Email sent successfully:", response.status, response.text);
      return { success: true, message: "Email sent successfully!" };
    } catch (error: any) {
      console.error("Email sending failed:", error);
      return { success: false, message: "Failed to send email." };
    }
  }
}

export const contactService = new ContactService();
